<!-- =========================================================================================
  File Name: makeDeposit.vue
  Description: Deposit index page
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 23062020
========================================================================================== -->
<template>
  <div id="page-deposit-create">
    <vx-card >
      <div id="loadingTab" class="vx-row w-full">

        <form-wizard class=" w-full" ref="formWizard" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" :nextButtonText="$t('Next')" :backButtonText="$t('Back')" :finishButtonText="$t('MakeDeposit')" @on-complete="ProcessDeposit">

          <tab-content :title="$t('ProviderMethods')" class="mb-5" icon="feather icon-home" :before-change="validateStep1">
            <form data-vv-scope="step-1">
              <div class="vx-col w-full">
                <provider-grid :selectedItem = "selectedItem" :data="this.providerMethodList" @set-selected-provider="updateSelectedItem"></provider-grid>
              </div>
            </form>
          </tab-content>

          <tab-content :title="$t('Account') + ' & ' + $t('Amount')" class="mb-5" icon="feather icon-briefcase" :before-change="validateStep2">
            <form data-vv-scope="step-2">
              <div class="vx-col w-full">
                <create-deposit ref="CreateDeposit" :selectedItem = "selectedItem" :data="providerMethodList"></create-deposit>
              </div>
            </form>
          </tab-content>

          <tab-content v-if="this.selectedItem == 2300 || this.selectedItem == 2301 || this.selectedItem == 2303 || this.selectedItem == 2304 || this.selectedItem == 2305" title="Payment" class="mb-5" icon="feather icon-image" :before-change="validateStep3">
            <form data-vv-scope="step-3">
                <create-deposit-crypto ref="tabCrypto" :selectedItem = "selectedItem" :data="providerMethodList" :qrData="CryptoInfo"></create-deposit-crypto>
            </form>
          </tab-content>

        </form-wizard>

      </div>
    </vx-card>
  </div>
</template>

<script>
import ProviderList from '@/views/components/transaction/ProviderList.vue'
import ProviderGrid from '@/views/components/transaction/ProviderGrid.vue'
import createDeposit from '@/views/components/transaction/createDeposit.vue'
import CreateDepositCrypto from '@/views/components/transaction/CreateDepositCrypto.vue'
import moduleTransactionMng from '@/store/transaction-mng/moduleTransactionMng.js'
import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  components:{
    ProviderList,
    createDeposit,
    ProviderGrid,
    FormWizard,
    TabContent,
    WizardStep,
    CreateDepositCrypto
  },
  data () { 
    return {
      selectedItem: -1,
      providerMethodList: [],
      CryptoInfo: {},
      providerMethods: [
        {
          ProviderMethodCode    : 1,
          name                  : 'AliPay',
          icon                  : 'alipay.png',
          msg                   : 'Are your going to meet me tonight?',
          ProviderMethodCategory: '[WT]'
        },
        { 
          ProviderMethodCode    : 5,
          name                  : 'Netellar',
          icon                  : 'neteller.png',
          msg                   : 'You got new order of goods.',
          ProviderMethodCategory: '[WT][CP]'
        },
        { 
          ProviderMethodCode    : 2,
          name    : 'FasaPay',
          msg      : 'Server have 99% CPU usage.',
          icon     : 'FasaPay.png',
          ProviderMethodCategory: '[CP]'
        },
        // { 
        //   ProviderMethodCode    : 3,
        //   title    : 'Local',
        //   msg      : 'Cake sesame snaps cupcake',
        //   icon     : 'local.png'
        // },
        // { ProviderMethodCode    : 4,
        //   title    : 'bankwire',
        //   msg      : 'Chocolate cake oat cake tiramisu',
        //   icon     : 'bankwire.png'
        // },
        // { ProviderMethodCode    : 5,
        //   title    : 'bitcoin',
        //   msg      : 'Chocolate cake oat cake tiramisu',
        //   icon     : 'bitcoin.png'
        // },
        // { ProviderMethodCode    : 6,
        //   title    : 'bitcoincash',
        //   msg      : 'Chocolate cake oat cake tiramisu15',
        //   icon     : 'bitcoincash.png'
        // },
        // { ProviderMethodCode    : 7,
        //   title    : 'creditcards',
        //   msg      : 'Chocolate cake oat cake tiramisu14',
        //   icon     : 'creditcards_1.png'
        // },
        // { ProviderMethodCode    : 44,
        //   title    : 'ethereum',
        //   msg      : 'Chocolate cake oat cake tiramisu13',
        //   icon     : 'ethereum.png'
        // },
        // { ProviderMethodCode    : 8,
        //   title    : 'litecoin',
        //   msg      : 'Chocolate cake oat cake tiramisu12',
        //   icon     : 'litecoin.png'
        // },
        // { ProviderMethodCode    : 9,
        //   title    : 'okpay',
        //   msg      : 'Chocolate cake oat cake tiramisu11',
        //   icon     : 'okpay.png'
        // },
        // { ProviderMethodCode    : 10,
        //   title    : 'Perfect-Money',
        //   msg      : 'Chocolate cake oat cake tiramisu10',
        //   icon     : 'Perfect-Money.png'
        // },
        { ProviderMethodCode    : 6,
          title    : 'Skrill',
          icon     : 'Skrill.png',
          msg      : 'Chocolate cake oat cake tiramisu10',
          ProviderMethodCategory: '[CP]'
        }
        // { ProviderMethodCode    : 12,
        //   title    : 'sticpay',
        //   msg      : 'Chocolate cake oat cake tiramisu10',
        //   icon     : 'sticpay.png',
        // },
        // { ProviderMethodCode    : 13,
        //   title    : 'usdc',
        //   msg      : 'Chocolate cake oat cake tiramisu10',
        //   icon     : 'usdc.png'
        // },
        // { ProviderMethodCode    : 14,
        //   title    : 'WebMoney',
        //   msg      : 'Chocolate cake oat cake tiramisu10',
        //   icon     : 'WebMoney.png'
        // },       
      ]
    }
  },
  methods: {

    updateSelectedItem (newValue) {
      this.selectedItem = newValue
      if (this.selectedItem >= 0) this.$refs.formWizard.nextTab()
    },
    ProcessDeposit () {
      // if (this.selectedItem !== 2300 && this.selectedItem !== 2310 && this.selectedItem !== 2303 && this.selectedItem !== 2304 && this.selectedItem !== 2305 )
      this.$refs.CreateDeposit.StartProcess()
    },
    validateStep1 () {
      return new Promise((resolve, reject) => {
        if (this.selectedItem >= 0) {
          resolve(true)
        } else {
          reject('correct all values')
        }
      })
    },
    validateStep2 () {
      return new Promise((resolve, reject) => {
        this.$vs.loading({
          container: '#loadingTab',
          type: 'sound',
          scale: 1
        })
        this.$refs.CreateDeposit.Process()
          .then((res) => {
            this.$vs.loading.close('#loadingTab > .con-vs-loading')
            if (this.selectedItem === 8000) {
              this.$vs.notify({
                title: 'Transaction Registered',
                text: 'The transaction was successfully registered',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
            }
            else if (this.selectedItem !== 2300 && this.selectedItem !== 2301 && this.selectedItem !== 2303 && this.selectedItem !== 2304 && this.selectedItem !== 2305) {
              if (res.data.isSuccess) window.location.href = res.data.data
              else reject('correct all values')
            } else {
              this.CryptoInfo = res.data
              console.info(this.$refs.tabCrypto.$refs.countdowntimer)
              this.$refs.tabCrypto.$refs.countdowntimer.timePassed = 0
            }
            resolve(true)
          })
          .catch(err => {
            this.$vs.loading.close('#loadingTab > .con-vs-loading')
            reject('correct all values')
          })
      })
    },
    validateStep3 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-3').then(result => {
          if (result) {
            alert('Form submitted!')
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    fetch_provider_data () {     
      this.$store.dispatch('TransactionMng/fetchProviderMethods', this.payload)
        .then(res => { 
          this.$vs.loading.close('#loadingTab > .con-vs-loading')
          this.providerMethodList = res.data.data
          console.error(res.data.data)
          /*if (this.providerMethodList.length === 1) {
            this.selectedItem = this.providerMethodList[0].id
            this.$refs.formWizard.nextTab()
          }*/
        })
        .catch(err => {
          console.error(err) 
        })
    }
  },
  created () {
    if (!moduleTransactionMng.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionMng)
      moduleTransactionMng.isRegistered = true
    }

    this.fetch_provider_data()

  },
  mounted () {
    this.$vs.loading({
      container: '#loadingTab',
      type: 'sound',
      scale: 1
    }) 

  }
}
</script>